import { render, staticRenderFns } from "./bodega-catena-zapata.vue?vue&type=template&id=06726410&scoped=true"
import script from "./bodega-catena-zapata.vue?vue&type=script&lang=js"
export * from "./bodega-catena-zapata.vue?vue&type=script&lang=js"
import style0 from "./bodega-catena-zapata.vue?vue&type=style&index=0&id=06726410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06726410",
  null
  
)

export default component.exports